import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions, throwExceptionErrors } from "../../../../utils/fetch";
export const GET_CASE_NPI_OPTIONS = "GET_CASE_NPI_OPTIONS";

export const service = async (data) => {
  const response: any = await callMvcApi({
    url: `/api/EsMD/GetCaseNpiOptions/${data.eaCaseId}/${data.eaAuditId}`,
    type: "GET",
    contentType: 'application/json',
    ...getDefaultOptions(),
  })
  throwExceptionErrors(response);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => Promise.resolve(mockData());

register(GET_CASE_NPI_OPTIONS, service, mock);
